import { Mail, Phone } from "lucide-react";
import { ASSETS, COMPANY } from "@/data/site";

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="relative py-24 md:py-32 bg-ink-800">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Team</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
            Ihr <span className="italic text-gold-soft">Ansprechpartner.</span>
          </h2>
          <p className="mt-5 text-zinc-400 max-w-2xl mx-auto">
            Direkter Kontakt. Klare Antworten. Persönliche Verantwortung.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div data-testid="team-card-ceo" className="grid grid-cols-1 md:grid-cols-5 gap-0 bg-ink-900 border border-ink-500/60 overflow-hidden">
            <div className="md:col-span-2 relative bg-gradient-to-br from-ink-700 to-ink-900">
              <img
                src={ASSETS.ceoPortrait}
                alt={`${COMPANY.ceo} · Geschäftsführer`}
                className="w-full h-full object-cover object-top md:h-[420px]"
              />
              <div className="absolute top-4 left-4 flex gap-1 text-gold">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="text-xs">★</span>
                ))}
              </div>
            </div>

            <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center">
              <p className="text-xs tracking-[0.3em] uppercase text-gold mb-3">Geschäftsführer</p>
              <h3 className="font-display text-3xl md:text-4xl text-white mb-4">{COMPANY.ceo}</h3>
              <p className="text-zinc-400 leading-relaxed mb-8">
                Als Geschäftsführer von Five Star Reinigung ist Wallat Ramo Ihr direkter
                Ansprechpartner — von der ersten Anfrage über das Vor-Ort-Gespräch bis zur
                erfolgreichen Übergabe Ihres Objekts.
              </p>

              <div className="space-y-3">
                <a
                  data-testid="team-phone"
                  href={COMPANY.phoneHref}
                  className="flex items-center gap-3 text-zinc-300 hover:text-gold transition-colors"
                >
                  <Phone size={16} className="text-gold" />
                  {COMPANY.phone}
                </a>
                <a
                  data-testid="team-email"
                  href={`mailto:${COMPANY.email}`}
                  className="flex items-center gap-3 text-zinc-300 hover:text-gold transition-colors break-all"
                >
                  <Mail size={16} className="text-gold" />
                  {COMPANY.email}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
